import { createContext } from "react";

export type DarkMode = "light" | "dark";

export interface DarkModeCtx {
  mode: DarkMode;
  toggle: () => void;
  setMode: (m: DarkMode) => void;
}

export const DarkModeContext = createContext<DarkModeCtx | undefined>(undefined);
